module.exports = __webpack_public_path__ + "public/images/generated-acting-drama.b2550bfd1de7c53cded80ee0929b3d5e.jpg";